export default __webpack_public_path__ + "static/media/subscribe-banner.06aa3ecd.png";